import InputMap from 'login-components/Common/Inputs/InputMap';
import autobind from 'autobind-decorator';
import { FormProps, reduxForm } from 'redux-form';
import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';
import AppTitleUpdater from 'login-components/Common/AppTitleUpdater';
import * as React from 'react';
import FormDialogFooter from 'login-components/Common/Form/FormDialog/FormDialogFooter';
import OldFormBody from '../FormComponents/OldFormBody';
import { hashHistory } from 'react-router';
import * as formUtils from 'login-utils/formUtils';
import '../LoginForm/login-form.scss';

const inputs: FormInput[] = [
  {
    ...InputMap.PasswordInput,
    name: 'password',
    identifier: 'password',
  },
];

export interface LoginFormPasswordOnlyProps extends FormProps<any, any, any> {
  errorMsg?: string;
  username?: string;
}

const FORM_ERROR_ID = 'LoginFormPasswordOnly-formError';

@autobind
export class LoginFormPasswordOnly extends React.Component<LoginFormPasswordOnlyProps, {}> {
  private loginFormRef = React.createRef<HTMLFormElement>();

  submitLogin() {
    formUtils.submitForm(this.loginFormRef.current!);
  }

  render() {
    const actionText = 'Sign in';
    const { handleSubmit, username, errorMsg, submitting } = this.props;
    return (
      <AppTitleUpdater text="Sign in to your account">
        <form
          ref={this.loginFormRef}
          action="/api/public/login"
          method="POST"
          className="LoginForm"
          id="it-LoginFormPasswordOnly"
          noValidate
          onSubmit={handleSubmit!(this.submitLogin)}
        >
          <input type="hidden" name="username" id="username" value={username} />
          <input type="hidden" name="redirectType" value={hashHistory.getCurrentLocation().pathname.substring(1)} />
          <div className="LoginForm-label">{username}</div>
          <OldFormBody inputs={inputs} errorId={FORM_ERROR_ID} errorMsg={errorMsg} showForgotPassword={true} />
          <FormDialogFooter>
            <PrimaryButton buttonId="it-LoginSubmit" disabled={submitting} text={actionText} />
          </FormDialogFooter>
        </form>
      </AppTitleUpdater>
    );
  }
}

const ConnectedLoginFormPasswordOnly = reduxForm({
  form: 'login',
  validate: values => formUtils.validate(inputs, values),
  onSubmitFail: syncErrors => formUtils.focusOnSubmitFail(syncErrors, FORM_ERROR_ID),
})(LoginFormPasswordOnly);

export default ConnectedLoginFormPasswordOnly;
